module.exports = __webpack_public_path__ + "img/freising_dom.d9643066.jpg";